import React from "react";

import { Box, Typography } from "@mui/material";
import { postfixes, symbols } from "root/utils";
import { colors } from "root/utils/color";

import { numberWithSpaces } from "root/js/utils";

const PercentDiffCell = ({
  percent: parentValue,
  diff,
  isNegative = false,
  empty = symbols.none,
}) => {
  const percent = Math.round(parentValue);
  const isPercentInvalid = percent === null || percent === undefined || isNaN(percent);
  const isDiffInvalid = diff === null || diff === undefined || isNaN(diff);

  const isGrow = percent > 0;
  const isGoodWay = isNegative !== isGrow;
  const color = percent ? (isGoodWay ? colors.green : colors.red) : colors.orange;
  const bgColor = `${color}33`;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {!isDiffInvalid && (
        <Typography fontSize={14} fontWeight={700}>
          {numberWithSpaces(diff, 0)}
          {postfixes.pcs}
        </Typography>
      )}

      {!isPercentInvalid ? (
        <Typography
          fontSize={14}
          sx={{
            color,
            backgroundColor: bgColor,
            padding: "1px 5px",
            borderRadius: "6px",
            fontWeight: 700,
          }}>
          {isGrow && "+"}
          {numberWithSpaces(percent, 0)}
          {postfixes.percent}
        </Typography>
      ) : (
        <Typography fontSize={14}>{empty}</Typography>
      )}
    </Box>
  );
};

export default PercentDiffCell;
